import { useState } from "react";



import { generateUUID } from "Utilities/generateUUID";

import { useUploadPhoto } from "../api/queries";

export function useUploadFile({
  fileInputRef,
  onUploadStart = () => {},
  onUploadComplete = () => {},
  onError = () => {},
}) {
  const [fileSizeErrorMessage, setFileSizeErrorMessage] = useState();
  const [percentUploaded, setPercentUploaded] = useState(0);

  const {
    mutate,
    isLoading: isUploading,
    reset,
    error,
  } = useUploadPhoto({
    onError: (err) => {
      onError();
      setPercentUploaded(0);
    },
    onSuccess: (res) => {
      onUploadComplete(res);
      setPercentUploaded(0);
    },
  });

  const handleFileUpload = (e) => {
    reset();
    const isValidSize = validateFileSize(fileInputRef.current.files[0].size);
    if (!isValidSize) {
      setFileSizeErrorMessage("File size is too large!");
      return;
    }

    const options = {
      onUploadProgress: ({ loaded, total }) => {
        let currentPercent = Math.floor((loaded * 100) / total);
        setPercentUploaded(currentPercent);
      },
    };

    // submit file
    const formData = new FormData();
    formData.append("qquuid", generateUUID());
    formData.append("qqfilename", fileInputRef.current.files[0].name);
    formData.append("qqtotalfilesize", fileInputRef.current.files[0].size);
    formData.append("qqfile", fileInputRef.current.files[0]);
    onUploadStart();

    mutate(formData, options);
  };

  return {
    handleFileUpload,
    isUploading,
    percentUploaded,
    error: fileSizeErrorMessage ?? error?.message,
    setFileSizeErrorMessage,
  };
}

const validateFileSize = (fileSize) => {
  const maxSize = 12000000;

  if (fileSize > maxSize) {
    return false;
  }

  return true;
};